import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { useTheme } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { BaseChartingCard } from "@src/appV2/redesign/Charting/Cards/BaseChartingCard";
import { ChartingCardWrapper } from "@src/appV2/redesign/Charting/Cards/ChartingCardWrapper";
import { Button } from "@src/appV2/redesign/components/Button";
// eslint-disable-next-line no-restricted-imports
import Pending from "@src/assets/images/pending.png";
import { differenceInMinutes } from "date-fns";
import { useHistory } from "react-router-dom";

import { type ChartingNoncompliance } from "../api/schema";
import { CHARTING_REDIRECT_PATH, CHARTING_REVIEW_DURATION_IN_HOURS } from "../constants";

interface ChartingReviewCardProps {
  chartingNoncompliance: ChartingNoncompliance;
}

export function ChartingReviewCard(props: ChartingReviewCardProps) {
  const { chartingNoncompliance } = props;
  const theme = useTheme();
  const history = useHistory();
  const {
    id: chartingNoncomplianceId,
    attributes: { deadlineToReview },
  } = chartingNoncompliance;
  const hoursUntilReviewDeadline = isDefined(deadlineToReview)
    ? Math.ceil(differenceInMinutes(new Date(deadlineToReview), new Date()) / 60)
    : CHARTING_REVIEW_DURATION_IN_HOURS;
  const daysUntilReviewDeadline = Math.ceil(hoursUntilReviewDeadline / 24);
  const daysUntilReviewDeadlineDisplay =
    daysUntilReviewDeadline === 1 ? "a day" : `${daysUntilReviewDeadline} days`;
  return (
    <ChartingCardWrapper image={Pending} background={theme.palette.charting?.review.gradient}>
      <BaseChartingCard
        title="Charting under Review"
        content={
          <Text variant="body1" textAlign="left">
            The workplace will review your charting within {daysUntilReviewDeadlineDisplay}
          </Text>
        }
        footer={
          <Button
            invert
            sx={{
              width: "fit-content",
            }}
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.CHARTING_NONCOMPLIANCE_SEE_DETAILS_REVIEW, {
                timestamp: new Date().toISOString(),
                chartingNoncomplianceId,
              });
              history.push(CHARTING_REDIRECT_PATH);
            }}
          >
            See details&nbsp;&nbsp;&nbsp;
            <CbhIcon type="chevron-right" size="xSmall" />
          </Button>
        }
      />
    </ChartingCardWrapper>
  );
}
